import React, { useEffect, useState } from "react";
import httpRequest from "../../../utils/Http";
import Select from "react-select";
import { toast } from "react-toastify";
import MyDataTable from "../../../component/MyDataTable";
import Switch from "../../../component/Switch";

const UpdateKam = ({ partner_id, role_id }) => {
  const [formData, setFormData] = useState({ partner_id });
  const [isSubmit, setSubmit] = useState(false);
  const [isDivVisible, setIsDivVisible] = useState(false);
  const [formErrors, setFormErrors] = useState({});
  const [kamlist, setkamlist] = useState([]);
  const [reloadList, setReload] = useState(true);

  const toggleDivVisibility = () => {
    setIsDivVisible(!isDivVisible);
  };

  useEffect(() => {
    (async () => {
      const agentData = await httpRequest(`getalldropdownkamlist`, {}, "GET");
      if (agentData.status === true && agentData.message) {
        //console.log(roleData.message);
        setkamlist(agentData.message);
      }
    })();
  }, []);

  const onSubmitHandler = (e) => {
    e.preventDefault();
    setSubmit(false);
    setFormErrors(validateFrom(formData));
    setSubmit(true);
  };

  const validateFrom = (data) => {
    const errors = {};
    if (!data.partner_id) {
      errors.partner_id = "Partner Id is required";
    }
    if (!data.agent_id) {
      errors.agent_id = "Key Account Manager is required";
    }
    return errors;
  };

  useEffect(() => {
    (async () => {
      if (Object.keys(formErrors).length === 0 && isSubmit) {
        const data = await httpRequest(
          "associatekamwithpartner",
          formData,
          "POST",
        );
        setSubmit(false);
        if (data.status === true && data.message) {
          toast.success(data.message);
          document.getElementById("kamcreate").reset();
          setFormData({ partner_id });
          setReload(true);
          setIsDivVisible(false);
        } else {
          toast.error(data.message);
        }
      }
    })();
    //eslint-disable-next-line
  }, [isSubmit, formErrors]);

  const columns = [
    {
      name: "SNo.",
      selector: (row) => "", // Placeholder, as we don't need to select data from the row itself
      cell: (_, index) => index + 1, // Use cell to render the incrementing number
    },
    {
      name: "Name",
      selector: (row) => row.agent_detail.name,
      wrap: true,
    },
    {
      name: "Email ID",
      selector: (row) => row.agent_detail.email,
      wrap: true,
    },

    {
      name: "Mobile Number",
      selector: (row) => row.agent_detail.mobile_number,
      wrap: true,
    },
    Number(role_id) === 1 && {
      name: "Status",
      selector: (row) =>
        Number(row.active) === 1 ? "Activated" : "DeActivated",
      cell: (row) => (
        <Switch
          isOn={Number(row.active) === 1 ? true : false}
          id={row.kam_id}
          handleToggle={(e) => {
            updateToggleHandler(row.kam_id, e.target.checked);
          }}
          onColor="#EF476F"
        />
      ),
      wrap: true,
    },
    {
      name: "Create Date",
      selector: (row) => new Date(row.createdAt).toDateString(),
      wrap: true,
    },
  ].filter(Boolean);

  const updateToggleHandler = async (kam_id, value) => {
    try {
      setReload(false);
      let postData = {
        kam_id,
        active: value === true ? 1 : 0,
      };
      const data = await httpRequest("updatekamstatus", postData, "POST");

      if (data.status === true && data.message) {
        setReload(true);

        toast.success(data.message);
      } else {
        toast.error(data.message);
      }
    } catch (error) {}
  };

  return (
    <div className="kam-shell">
      {isDivVisible && (
        <div className="kam-form-panel mb-4">
          <div className="card kam-card">
            <div className="card-header kam-header">
              <h3 className="card-title mb-0">Add Key Account Manager</h3>
              <button
                type="button"
                className="btn btn-sm btn-light btn-outline-secondary"
                onClick={toggleDivVisibility}
              >
                <i className="fas fa-times"></i>
              </button>
            </div>

            <form
              className="card-body kam-form"
              id="kamcreate"
              onSubmit={onSubmitHandler}
              action="javascritp:void(0)"
            >
              <div className="row">
                <div className="col-md-8">
                  <div className="form-group">
                    <label htmlFor="agent_id" className="form-label">
                      Name <span className="text-danger">*</span>
                    </label>
                    <Select
                      name="agent_id"
                      classNamePrefix="kam-select"
                      options={kamlist}
                      value={
                        kamlist.find(
                          (obj) => obj.value === formData.agent_id,
                        ) || null
                      }
                      onChange={(val) => {
                        setFormData({ ...formData, agent_id: val.value });
                      }}
                      placeholder="Select KAM"
                    />
                    {formErrors.agent_id && (
                      <div className="invalid-feedback d-block">
                        {formErrors.agent_id}
                      </div>
                    )}
                  </div>
                </div>
              </div>

              <div className="d-flex justify-content-end mt-3">
                <button type="submit" className="btn btn-primary">
                  <i className="fas fa-save mr-2"></i>
                  Save Changes
                </button>
              </div>
            </form>
          </div>
        </div>
      )}

      <div className="card kam-card kam-list-card">
        <div className="card-header kam-header kam-list-header">
          <h3 className="card-title mb-0">Partner KAM List</h3>
          <button
            type="button"
            className="btn btn-primary btn-sm kam-add-btn"
            onClick={toggleDivVisibility}
          >
            <i className="fas fa-plus mr-2"></i>
            {isDivVisible === false ? "Add New KAM" : "Close"}
          </button>
        </div>

        <div className="card-body">
          <MyDataTable
            reloadList={reloadList}
            columns={columns}
            getDataListURL={`getpartnerkamlist?partner_id=${partner_id}`}
            setReload={setReload}
            exportName={"partnerkamlist"}
          />
        </div>
      </div>
    </div>
  );
};

export default UpdateKam;
